export const SET_CLIENTS = 'SET_CLIENTS';



// WEBPACK FOOTER //
// ./src/containers/common/clients/constants.js